import { useMemo } from "react"
import { TimeZoneService } from "services";

const luxonDefaultTimezone = 'local';

// Expects to be passed the user's chosen timezone preference.
// Returns a timezone that luxon will accept. If the user doesn't have a timezone,
// or if it isn't valid, it returns luxon's default timezone "local".
export function useLuxonTimezone(userTimezone: string): {timezone: string, hasTimezone: boolean, isTimezoneValid: boolean} {
    if (!userTimezone) return {
        hasTimezone: false,
        isTimezoneValid: true,
        timezone: luxonDefaultTimezone,
    };

    return useMemo(() => {
        const isValid = TimeZoneService.isValidTimeZone(userTimezone);

        if (!isValid) {
            console.warn('Invalid timezone. Showing events in local time. Timezone: ', userTimezone);
            return {
                hasTimezone: true,
                isTimezoneValid: false,
                timezone: luxonDefaultTimezone,
            }
        }

        return {
            hasTimezone: true,
            isTimezoneValid: true,
            timezone: userTimezone,
        };
    }, [userTimezone]);
}